import { genericActions } from "../_helpers/ActionErrorWrapper";

import { LicensesService } from "../_services/LicensesService";
import { LicenseMapper } from "../_mappers/LicenseMapper";
import { DistributorAdminLocationMapper } from "../_mappers/DistributorAdminLocationMapper";
import { LicenseCollection } from "../_generics/LicenseCollection";
import { LicensesSecondaryViewStore } from "../_stores/LicensesSecondaryViewStore";

export const LicensesActions = {    
    changeSecondaryView: LicensesSecondaryViewStore.actionSet,

    //REMOTE
    listLicenses,
    assignLicense,
    assignLicenseBulk,
    getAdminLocations,
    renewLicense,
    cancelLicense,
    reactivateLicense,

    //PRIVATE
    _listLicensesSuccess: LicenseCollection.actionListItemsSuccess,
    _updateLicenseSuccess: LicenseCollection.actionUpdateItemSuccess,
};

function listLicenses() {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const serverLicenses = await LicensesService.listLicenses();
            serverLicenses.sort((a, b) => b.id - a.id);
            dispatch(LicensesActions._listLicensesSuccess(
                LicenseMapper.allServerToLocal(serverLicenses),
            ));
        }
    };
}

function assignLicense({
    locationID, 
    email, 
    licenseTypeUID,
    quantity,
    createVirtualClockin,
} = {}) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));
    
        async function asyncAction() {
            const serverLicense = await LicensesService.assignLicense({
                locationID,
                email,
                licenseTypeUID,
                quantity,
                createVirtualClockin,
            });
    
            const license = LicenseMapper.serverToLocal(serverLicense);
            dispatch(LicensesActions._updateLicenseSuccess(license));
            return license;
        }
    };
}

function renewLicense({
    uid,
} = {}) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));
    
        async function asyncAction() {
            const serverLicense = await LicensesService.renewLicense({
                uid
            });
    
            const license = LicenseMapper.serverToLocal(serverLicense);
            dispatch(LicensesActions._updateLicenseSuccess(license));
            return license;
        }
    };
}

function cancelLicense({
    uid,
} = {}) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));
    
        async function asyncAction() {
            const serverLicense = await LicensesService.cancelLicense({
                uid
            });
    
            const license = LicenseMapper.serverToLocal(serverLicense);
            dispatch(LicensesActions._updateLicenseSuccess(license));
            return license;
        }
    };
}

function reactivateLicense({
    uid,
} = {}) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));
    
        async function asyncAction() {
            const serverLicense = await LicensesService.reactivateLicense({
                uid
            });
    
            const license = LicenseMapper.serverToLocal(serverLicense);
            dispatch(LicensesActions._updateLicenseSuccess(license));
            return license;
        }
    };
}

function getAdminLocations(email) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const serverLocations = await LicensesService.getAdminLocations(email);
            return DistributorAdminLocationMapper.allServerToLocal(serverLocations);
        }
    };
}

function assignLicenseBulk({
    email,
    licenseTypeUID,
    quantity,
    locationIds,
    createVirtualClockin,
} = {}) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const result = await LicensesService.assignLicenseBulk({
                email,
                licenseTypeUID,
                quantity,
                locationIds,
                createVirtualClockin,
            });

            const licenses = LicenseMapper.allServerToLocal(result.assigned ?? []);
            licenses.forEach(license =>
                dispatch(LicensesActions._updateLicenseSuccess(license))
            );

            return {
                assigned: licenses,
                skippedLocationIds: result.skipped_location_ids ?? [],
                notFoundLocationIds: result.not_found_location_ids ?? [],
            };
        }
    };
}
